import { render, staticRenderFns } from "./AddGiftcardModal.vue?vue&type=template&id=078b3854&"
import script from "./AddGiftcardModal.vue?vue&type=script&lang=js&"
export * from "./AddGiftcardModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports